<template>
  <div class="questionEditWrapper">
    <div class="contentSide">
      <div class="examinationTypeBar" v-if="!ifQuestion">
        组卷方式
        <el-radio-group
          v-model="questionData.constitute"
          size="small"
          style="margin-left: 20px"
        >
          <el-radio :label="1" border>固定试题组卷</el-radio>
          <el-radio :label="2" border>随机抽题组卷</el-radio>
          <el-radio :label="3" border>固定+随机</el-radio>
        </el-radio-group>
      </div>
      <div class="examinationChooseBox">
        <el-tabs v-if="questionData.constitute == 3" v-model="constituteType">
          <el-tab-pane label="固定试题" name="固定试题"></el-tab-pane>
          <el-tab-pane label="随机试题" name="随机试题"></el-tab-pane>
        </el-tabs>
        <div class="questionSelectContainer">
          <div
            v-if="
              questionData.constitute == 1 ||
              (constituteType == '固定试题' && questionData.constitute == 3)
            "
          >
            <div class="actBar" v-if="staticQuestionList.length > 0">
              <el-checkbox
                :value="staticIfSelectAll"
                @change="staticChooseAll"
                style="margin-right: 15px"
              ></el-checkbox>
              <el-button
                icon="el-icon-plus"
                type="primary"
                @click="selectQuestionData.ifShow = true"
                size="small"
                >添加试题</el-button
              >
              <el-button
                icon="el-icon-delete-solid"
                type="warning"
                plain
                size="small"
                @click="staticQuestionDelete"
                >删除试题</el-button
              >

              <el-popover
                v-if="!ifQuestion"
                placement="bottom"
                width="200"
                style="margin: 0 10px"
                size="small"
                v-model="ifEditAllScore"
              >
                <h3>请输入分数</h3>
                <el-input
                  size="mini"
                  style="margin: 8px 0"
                  type="number"
                  v-model="allScore"
                ></el-input>
                <div style="text-align: right">
                  <el-button
                    size="mini"
                    type="text"
                    @click="ifEditAllScore = false"
                    >取消</el-button
                  >
                  <el-button type="primary" size="mini" @click="confirmAllScore"
                    >确定</el-button
                  >
                </div>
                <el-button slot="reference" type="primary" plain size="small"
                  >修改分数</el-button
                >

                <!-- <el-button
                          type="text"
                          slot="reference"
                          @click="item.editValue = item.score"
                          >{{ item.score }}分</el-button
                        > -->
              </el-popover>

              <el-button
                type="primary"
                v-if="!ifQuestion"
                plain
                style="margin-right: 10px"
                size="small"
                >试题查重</el-button
              >
              <el-popover width="200" trigger="hover" v-if="!ifQuestion">
                <div>
                  <el-button
                    size="small"
                    type="text"
                    @click="sortStaticQuestionList('questionGroupId')"
                  >
                    按试题分类 </el-button
                  ><br />
                  <el-button
                    size="small"
                    type="text"
                    @click="sortStaticQuestionList('questionTypeId')"
                  >
                    按相同题型
                  </el-button>
                </div>
                <el-button slot="reference" type="primary" plain size="small"
                  >排序 <i class="el-icon-arrow-down"></i
                ></el-button>
              </el-popover>
            </div>
            <div class="emptyTips" v-if="staticQuestionList.length == 0">
              <h1>无题</h1>
              <p>
                点击“添加试题“,可题库随机选题、手工选题，每个人考试的试题一样！
              </p>
              <el-button
                icon="el-icon-plus"
                type="primary"
                @click="selectQuestionData.ifShow = true"
                >添加试题</el-button
              >
            </div>
            <div class="tipsBar" v-if="staticQuestionList.length > 0">
              现在共计
              <b class="orangeFont">{{ staticQuestionList.length }}</b> 题
              总共<b class="orangeFont">{{
                staticQuestionList.reduce(
                  (total, item) => total - -item.score,
                  0
                )
              }}</b
              >分
            </div>
            <div class="questionList">
              <transition-group tag="ul" name="flip-list" class="item">
                <li
                  draggable="true"
                  :key="'question' + (item.questionId || item.id)"
                  v-for="(item, index) in staticQuestionList"
                  @dragstart="dragstart(item, 'staticQuestionList')"
                  @dragover="dragover(item, 'staticQuestionList')"
                >
                  <el-checkbox v-model="item.choose"></el-checkbox>
                  <div class="staticQuestionBox">
                    <div class="staticDetailBar titleBar">
                      <div class="left">
                        <span class="blueFont blueBorder"
                          >{{ index + 1 }}/{{ staticQuestionList.length }}</span
                        ><span class="blueFont blueBorder">{{
                          item.typeName || item.questionType || item.type
                        }}</span
                        >{{ item.content | removeLabel }}
                      </div>
                      <div class="right">
                        <el-popover
                          placement="bottom"
                          width="200"
                          v-model="item.ifEdit"
                        >
                          <h3>请输入分数</h3>
                          <el-input
                            size="mini"
                            style="margin: 8px 0"
                            type="number"
                            @input="
                              (e) => {
                                changechange(e, item);
                              }
                            "
                            :value="item.editValue"
                          ></el-input>
                          <div style="text-align: right">
                            <el-button
                              size="mini"
                              type="text"
                              @click="item.ifEdit = false"
                              >取消</el-button
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              @click="
                                item.score = item.editValue;
                                item.ifEdit = false;
                              "
                              >确定</el-button
                            >
                          </div>
                          <el-button
                            type="text"
                            slot="reference"
                            @click="item.editValue = item.score"
                            >{{ item.score }}分</el-button
                          >
                        </el-popover>
                        &emsp;
                        <!-- <span>展开</span> -->
                      </div>
                    </div>
                    <div class="greyFont staticDetailBar">
                      标签：
                      <div class="circlelabel">简单</div>
                    </div>
                    <div class="greyFont staticDetailBar">
                      分类:{{ item.groupName }}&ensp;&ensp; 作者:{{
                        " 系统管理员"
                      }}&ensp;&ensp;更新于{{ " " + item.updateDate }}
                    </div>
                  </div>
                </li>
              </transition-group>
            </div>
          </div>
          <div
            v-if="
              questionData.constitute == 2 ||
              (constituteType == '随机试题' && questionData.constitute == 3)
            "
          >
            <div class="actBar" v-if="randomInfoList.length > 0">
              <el-checkbox
                :value="randomIfSelectAll"
                @change="randomChooseAll"
                style="margin-right: 15px"
              ></el-checkbox>
              <el-button
                icon="el-icon-plus"
                type="primary"
                @click="showRandomTypeDialog"
                >添加分类</el-button
              >
              <el-button
                icon="el-icon-delete-solid"
                type="warning"
                plain
                @click="randomGroupDelete"
                >删除分类</el-button
              >

              <el-popover width="200" trigger="hover" style="margin-left: 10px">
                <div>
                  <el-button
                    type="text"
                    size="small"
                    @click="sortStaticQuestionList('questionGroupId')"
                  >
                    按试题分类 </el-button
                  ><br />
                  <el-button
                    type="text"
                    size="small"
                    @click="sortStaticQuestionList('questionTypeId')"
                  >
                    按相同题型
                  </el-button>
                </div>
                <el-button slot="reference" type="primary" plain
                  >排序 <i class="el-icon-arrow-down"></i
                ></el-button>
              </el-popover>
            </div>
            <div class="emptyTips" v-if="randomInfoList.length == 0">
              <h1>无题</h1>
              <p>
                点击“添加分类“按钮添加,题库随机选题，每个人考试的试题不一样！
              </p>
              <el-button
                icon="el-icon-plus"
                type="primary"
                @click="showRandomTypeDialog"
                >添加分类</el-button
              >
            </div>
            <transition-group name="flip-list">
              <div
                class="questionGroupBar"
                v-for="(item, index) in randomInfoList"
                :key="'groupCount' + item.questionGroupId"
                :draggable="item.draggable"
                @dragstart="dragstart(item, 'randomInfoList')"
                @dragover="dragover(item, 'randomInfoList')"
                @dragend="item.draggable = false"
              >
                <div class="questionGroupTitle">
                  <el-checkbox
                    v-model="item.choose"
                    @change="$forceUpdate()"
                    style="margin-right: 15px"
                  ></el-checkbox>
                  <i
                    class="el-icon-s-unfold"
                    @mousedown.stop="makeDraggable(item)"
                    @mouseup="item.draggable = false"
                  ></i>

                  <div class="groupName" @click="item.ifMore = !item.ifMore">
                    {{ item.groupName }}({{ item.groupNum }}道试题)<i
                      class="el-icon-arrow-down"
                    ></i>
                  </div>
                  <div class="selectDetail">
                    {{ item | questionCountCalculate }}
                  </div>
                </div>
                <div
                  class="questionTypeList"
                  v-if="item.examRandomDTOList.length > 0"
                  :style="{
                    height: item.ifMore
                      ? 40 * item.examRandomDTOList.length + 'px'
                      : '0px',
                  }"
                >
                  <div
                    class="typeCell"
                    v-for="(type, typeIdx) in item.examRandomDTOList"
                    :key="'typeCount' + typeIdx"
                  >
                    <div class="typeName">
                      {{ type.typeName }}({{ type.totalNum }}道试题)
                    </div>
                    <div class="typeNum">
                      抽选<el-input
                        size="small"
                        type="number"
                        min="0"
                        :max="type.totalNum"
                        v-model="type.randomNum"
                        style="width: 80px"
                        @change="
                          (val) => {
                            if (val > type.totalNum) {
                              type.randomNum = type.totalNum;
                            }
                          }
                        "
                      ></el-input
                      >道试题
                    </div>
                    <div class="typeScore">
                      每题<el-input
                        size="small"
                        type="number"
                        min="0"
                        v-model="type.score"
                        style="width: 60px"
                      ></el-input
                      >分
                    </div>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
    <div class="overviewSide" v-if="!ifQuestion">
      <div class="actBox">
        <!-- <div class="overviewTitle">考试时长</div>
        <div class="centerFont"> 
          总时长：120分钟
          <el-button type="text">修改 <i class="el-icon-edit"></i> </el-button>
        </div> -->
        <div class="table">
          <div class="tableCell">
            <div class="overviewTitle">总分</div>
            <div class="cellData">
              {{ totalQuestionScore }}
            </div>
          </div>
          <div class="tableCell">
            <div class="overviewTitle">总题数</div>
            <div class="cellData">{{ totalQuestionCount }}</div>
          </div>
          <!-- <div class="tableCell">
            <div class="overviewTitle">总部分</div>
            <div class="cellData">2</div>
          </div> -->
        </div>
        <el-button type="primary" style="width: 100%" @click="$emit('nextStep')"
          >保存</el-button
        >
      </div>
    </div>
    <el-dialog
      :visible.sync="selectQuestionData.ifShow"
      width="80%"
      top="5vh"
      append-to-body
      center
    >
      <static-question-select
        :questionIds="staticQuestionIds"
        @appendQuestion="appendQuestion"
        :ifQuestion="ifQuestion"
      ></static-question-select>
    </el-dialog>
    <el-dialog
      :visible.sync="selectRandomQuestionType.ifShow"
      width="60%"
      top="5vh"
      append-to-body
      center
    >
      <!-- @node-click="nodeClick" -->
      <el-tree
        :data="questionTypeTree"
        :check-on-click-node="true"
        show-checkbox
        :expand-on-click-node="false"
        default-expand-all
        node-key="id"
        ref="randomQuestionTypeTree"
        fullscreen
        highlight-current
        :props="{ label: 'title' }"
      >
      </el-tree
      ><template slot="footer"
        ><el-button @click="selectRandomQuestionType.ifShow = false"
          >取消</el-button
        >
        <el-button type="primary" @click="randomQuestionTypeConfirm"
          >选择</el-button
        ></template
      >
    </el-dialog>
  </div>
</template>


<script>
import staticQuestionSelect from "@/views/examination-management/component/staticQuestionSelect.vue";
import randomQuestionSelect from "@/views/examination-management/component/randomQuestionSelect.vue";
import { getPaperQuestionData } from "@/api/examination/examination.js";
import { getQuestionType, getQuestionCount } from "@/api/question.js";
export default {
  data() {
    return {
      constituteType: "固定试题",
      questionData: {
        name: "",
        examId: "",
        constitute: 1,
        questionGroupId: "",
        questionScores: "",
        questionIds: "",
        sortWay: "",
        typeInfoList: "",
      },
      randomInfoList: [],
      draggingItem: null,
      lastItem: null,

      questionTypeTree: [],
      // staticQuestionIds: [],
      selectQuestionData: {
        ifShow: false,
      },
      selectRandomQuestionType: { ifShow: false },
      groupNodeList: [],
      ifEditAllScore: false,
      allScore: 0,
    };
  },
  props: {
    examData: {
      type: Object, ///type: [String, Number],
      default: () => {
        return {
          name: "",
          exName: "",
          exGroupId: "",
          description: "",
          imageUrl: "",
          keyWord: "",
          examId: 0,
        };
      },
    },
    ifQuestion: {
      type: Boolean,
      default: false,
    },
    staticQuestionList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    staticQuestionIds() {
      let back = this.staticQuestionList.map((item) => item.questionId);
      return back;
    },
    staticIfSelectAll() {
      return this.staticQuestionList.every((item) => item.choose);
    },
    randomIfSelectAll() {
      return this.randomInfoList.every((item) => item.choose);
    },
    totalQuestionCount() {
      let count = this.staticQuestionList.length;

      this.randomInfoList.forEach((random) => {
        count += random.examRandomDTOList.reduce((total, item) => {
          total -= -item.randomNum;
          return total;
        }, 0);
      });
      return count;
    },
    totalQuestionScore() {
      let score = this.staticQuestionList.reduce(
        (total, item) => total - -item.score,
        0
      );

      this.randomInfoList.forEach((random) => {
        score += random.examRandomDTOList.reduce((total, item) => {
          total -= -(item.score * item.randomNum);
          return total;
        }, 0);
      });
      return score;
    },
  },
  filters: {
    questionCountCalculate(item) {
      let [num, score] = item.examRandomDTOList.reduce(
        (total, item) => {
          total[0] -= -item.randomNum;
          total[1] -= -(item.score * item.randomNum);
          return total;
        },
        [0, 0]
      );
      return `抽取 ${num} 道题 总共 ${score} 分`;
    },
    removeLabel(str) {
      return str.replace(/<.*?>/gi, "");
    },
  },
  components: { staticQuestionSelect, randomQuestionSelect },
  created() {},
  mounted() {
    getQuestionType().then((data) => {
      data.groupNodeList.unshift({
        description: null,
        id: 0,
        parentId: 0,
        title: "所有分类",
      });
      this.questionTypeTree = data.groupNodeList;
    });
    console.log(this.$route.query.id && !this.ifQuestion);
    if (this.$route.query.id && !this.ifQuestion) {
      getPaperQuestionData({ examId: this.$route.query.id }).then((data) => {
        this.questionData.constitute = data.constitute;
        this.typeInfoList = data.typeInfoList;
        data.staticQuestionList = data.staticQuestionList || [];
        data.staticQuestionList.forEach((item) => {
          item.choose = false;
        });
        this.staticQuestionList = data.staticQuestionList;
        if (data.randomInfoList && data.randomInfoList.length > 0) {
          data.randomInfoList.forEach((item) => {
            item.ifMore = false;
            item.choose = false;
            item.draggable = false;
            item.totalCount = 0;
            item.totalScore = 0;
            // item.questionGroupId = item.groupId;
            this.randomInfoList.push(item);
          });
        }

        this.$forceUpdate();
      });
    }
  },
  methods: {
    changechange(e, item) {
      item.editValue = e;
      this.$forceUpdate();
    },
    sortStaticQuestionList(type) {
      console.log("排个序");
      this.staticQuestionList.sort((a, b) => a[type] - b[type]);
    },
    formPaper() {
      if (
        this.questionData.constitute == 3 &&
        (this.staticQuestionList.length < 1 || this.randomInfoList.length < 1)
      ) {
        this.$message.error(
          "在固定加随机组卷方式时，固定试题和随机试题都不可为空"
        );
        return;
      }
      let idAndScoreList = this.staticQuestionList.map((item) => {
        return { questionId: item.questionId, questionScore: item.score };
      });
      this.$emit("formThePaper", {
        randomInfoList: this.randomInfoList,
        constitute: this.questionData.constitute,
        idAndScoreList: idAndScoreList,
        typeInfoList: [
          { typeId: 1, typeName: "单选题" },
          { typeId: 2, typeName: "多选题" },
          { typeId: 3, typeName: "判断题" },
          { typeId: 4, typeName: "填空题" },
          { typeId: 5, typeName: "问答题" },
        ],
      });
    },
    appendQuestion(data, options) {
      console.log(data);
      if (!options || !options.ifHandAppend) {
        this.selectQuestionData.ifShow = false;
        data.forEach((item) => {
          if (!this.staticQuestionIds.includes(item.questionId)) {
            this.$set(item, "editValue", 0);
            // item.editValue = 0;
            item.choose = false;
            this.staticQuestionList.push(item);
            // this.staticQuestionIds.push(item.questionId);
          }
        });
      } else if (options && options.ifHandAppend) {
        data.forEach((item) => {
          if (!this.staticQuestionIds.includes(item.questionId)) {
            this.$set(item, "editValue", 0);
            this.$set(item, "choose", false);
            this.staticQuestionList.push(item);
            // this.staticQuestionIds.push(item.questionId);
          } else {
            this.staticQuestionList.splice(
              this.staticQuestionList.findIndex((qust) => qust.id == item.id),
              1
            );
          }
        });
      }
      this.$emit("eventUp", this.staticQuestionList, { type: "staticChange" });
    },
    confirmAllScore() {
      this.staticQuestionList
        .filter((item) => item.choose)
        .forEach((item) => {
          item.score = this.allScore;
          this.ifEditAllScore = false;
        });
    },
    randomGroupDelete() {
      this.randomInfoList = this.randomInfoList.filter((item) => !item.choose);
    },
    staticQuestionDelete() {
      this.$confirm(
        `确认删除此${
          this.staticQuestionList.filter((item) => item.choose).length
        }道试题吗`,
        "提示",
        {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.staticQuestionList = this.staticQuestionList.filter(
          (item) => !item.choose
        );
        this.$emit("eventUp", this.staticQuestionList, {
          type: "staticChange",
        });
      });
    },
    staticChooseAll(data, event) {
      if (this.staticQuestionList.some((item) => item.choose)) {
        this.staticQuestionList.forEach((item) => (item.choose = false));
      } else {
        this.staticQuestionList.forEach((item) => (item.choose = true));
      }
    },
    randomChooseAll(data, event) {
      if (this.randomInfoList.some((item) => item.choose)) {
        this.randomInfoList.forEach((item) => (item.choose = false));
        this.$forceUpdate();
      } else {
        this.randomInfoList.forEach((item) => (item.choose = true));
        this.$forceUpdate();
      }
    },
    dragstart(item) {
      this.draggingItem = item;
    },
    dragover(item, listName) {
      let dragList = this[listName];
      if (item !== this.draggingItem && this.lastItem !== item) {
        const fromIndex = dragList.indexOf(this.draggingItem);
        const toIndex = dragList.indexOf(item);
        const temp = dragList[fromIndex];
        dragList[fromIndex] = dragList[toIndex];
        dragList[toIndex] = temp;
        this[listName] = [...dragList];
      }
      this.lastItem = item;
    },
    randomQuestionTypeConfirm() {
      let nodes = this.$refs.randomQuestionTypeTree.getCheckedNodes();
      let groupIds = nodes.map((item) => item.id);

      getQuestionCount({
        groupIds: "[" + groupIds.toString() + "]",
      }).then((data) => {
        let groupIds = this.randomInfoList.map((item) => item.questionGroupId);
        let randomInfoList = [];
        data.forEach((item) => {
          item.examRandomDTOList.forEach((type) => (type.randomNum = 0));
          if (!groupIds.includes(item.groupId)) {
            item.ifMore = false;
            item.draggable = false;
            item.totalCount = 0;
            item.totalScore = 0;
            item.questionGroupId = item.groupId;
            this.randomInfoList.push(item);
          }
        });
        this.selectQuestionData.ifShow = false;
      });
      this.selectRandomQuestionType.ifShow = false;
    },
    nodeClick(data, node) {
      let checkedKeys = this.$refs.randomQuestionTypeTree.getCheckedKeys();
      if (data.id && !checkedKeys.includes(0)) {
        // 点击的不是所有分类且没选择所有分类
        if (checkedKeys.includes(data.id)) {
          checkedKeys.splice(checkedKeys.indexOf(data.id), 1);
        } else {
          checkedKeys.push(data.id);
        }
      } else if (data.id && checkedKeys.includes(0)) {
        // 点击的不是所有分类且已选择所有分类
        checkedKeys = [data.id];
      } else {
        // 点击所有分类
        checkedKeys = [data.id];
      }
      this.$refs.randomQuestionTypeTree.setCheckedKeys(checkedKeys);
    },
    makeDraggable(item) {
      item.draggable = true;
      document.onmouseup = () => {
        item.draggable = false;
      };
    },
    showRandomTypeDialog() {
      this.selectRandomQuestionType.ifShow = true;
      let checkedKeys = this.randomInfoList.map((item) => item.questionGroupId);
      this.$nextTick(() => {
        this.$refs.randomQuestionTypeTree.setCheckedKeys(checkedKeys);
      });
    },
  },
};
</script>

<style scoped lang="less">
.questionEditWrapper {
  position: relative;
  display: flex;
  .overviewSide {
    flex: 1;
    margin-left: 10px;
    text-align: center;
    .actBox {
      padding: 20px;
      background: #fff;

      .overviewTitle {
        background: #f0f0f0;
        font-weight: bold;
        line-height: 30px;
        font-size: 16px;
      }
      .table {
        display: flex;
        margin: 10px 0;
        .tableCell {
          flex: 1;
        }
      }
    }
  }
  .contentSide {
    // height: calc(100vh - 110px);
    overflow: scroll;
    flex: 3;
  }
  .examinationTypeBar {
    padding: 15px;
    background: #fff;
    margin-bottom: 20px;
  }
  .title {
    font-size: 1.2em;
    position: relative;
    margin: 10px 0;
  }
  .title::after {
    content: "";
    width: 4px;
    height: 100%;
    background: #36aafd;
    position: absolute;
    top: 0;
    left: -10px;
  }
  /deep/ .el-radio {
    margin-right: 0;
  }
  .examinationChooseBox {
    padding: 15px;
    background: #fff;
    .questionSelectContainer {
      .actBar {
      }
      .tipsBar {
        margin: 10px 0;
      }
      .emptyTips {
        text-align: center;
        padding: 100px 0;
      }
      .questionGroupBar {
        border: 1px solid #ccc;
        border-radius: 4px;
        margin: 5px;
        .questionGroupTitle {
          display: flex;
          align-items: center;
          line-height: 40px;
          padding: 0 10px;
          i {
            line-height: inherit;
            margin-right: 10px;
            font-size: 20px;
          }
          .groupName {
            min-width: 300px;
            margin-right: 15px;
            cursor: pointer;
            flex: 1;
          }
          .selectDetail {
            text-align: right;
            min-width: 150px;
          }
        }
        .questionTypeList {
          overflow: hidden;
          // margin: 5px 0;
          transition: height 0.8s;
          .typeCell {
            height: 40px;
            display: flex;
            line-height: 40px;
            .typeName {
              margin-left: 60px;
              min-width: 305px;
            }
            .typeNum {
              margin: 0 10px;
            }
            .typeScore {
            }
          }
        }
      }
    }
  }
  .staticQuestionBox {
    border: 1px solid #ccc;
    flex: 1;
    margin-left: 20px;
    padding: 10px 15px;
    .staticDetailBar {
      margin: 10px 0;
    }
    .titleBar {
      display: flex;
      justify-content: space-between;
      .left {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        padding: 2px 0;
        flex: 1;
      }
      .right {
        width: 100px;
        text-align: right;
      }
    }
  }
  .staticQuestionBox:hover {
    border-color: #409eff;
  }
}
.flip-list-move {
  transition: transform 0.3s;
}

ul.item {
  list-style-type: disc;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-inline-start: 0;
}
.item li {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}
.blueFont {
  color: #409eff;
}
.greyFont {
  color: #999;
}
.circlelabel {
  display: inline-block;
  border: 1px solid #ccc;
  padding: 6px;
  line-height: 16px;
  margin-right: 10px;
  border-radius: 15px;
}
.blueBorder {
  border: 1px solid #409eff;
  margin-right: 5px;
  border-radius: 2px;
  padding: 2px 4px;
}
/deep/ .el-checkbox__inner {
  height: 20px;
  width: 20px;
}
/deep/ .el-checkbox__inner::after {
  width: 4px;
  height: 12px;
  left: 6px;
  top: 0;
  border-width: 2px;
}
.el-input {
  margin: 0 8px;
}
.orangeFont {
  color: #ff962a;
}
</style>
